
import { Component, Vue } from "vue-property-decorator";
import ModalTitle from "@/lib/model/exam/modal-title";
import ModalHeader from "@/components/modal-header.vue";

// 面试链接
@Component({
  components: {
    ModalHeader
  }
})
export default class ExamLink extends Vue {
  name = "exam-link";
  link = "";
  modalTitle: ModalTitle = new ModalTitle();

  created() {
    this.modalTitle.title = "面试链接";
    this.modalTitle.hasDesc = true;
    this.modalTitle.desc = "肯德基餐厅储备经理校招-WJW36";
  }
}
